import Vue from "vue";

Vue.filter("time", value => {
  let unix = Date.parse(value);
  let date = new Date(unix);

  let hours = date.getUTCHours();
  let minutes = date.getUTCMinutes();

  return (
    hours.toString().padStart(2, "0") +
    ":" +
    minutes.toString().padStart(2, "0")
  );
});
